import { repositories } from '../repositories';
import type { CompanyConfig } from '../repositories/CompanyConfigRepository';

/**
 * Service for company configuration operations
 */
export class CompanyConfigService {
  /**
   * Get all company configurations
   */
  async getAllCompanies(): Promise<CompanyConfig[]> {
    return await repositories.companyConfigs.findAll();
  }

  /**
   * Get all active companies
   */
  async getActiveCompanies(): Promise<CompanyConfig[]> {
    return await repositories.companyConfigs.getActiveCompanies();
  }

  /**
   * Get active companies count
   */
  async getActiveCompaniesCount(): Promise<number> {
    return await repositories.companyConfigs.getActiveCompaniesCount();
  }

  /**
   * Get company by ID
   */
  async getCompanyById(id: string): Promise<CompanyConfig | null> {
    return await repositories.companyConfigs.findById(id);
  }

  /**
   * Create new company
   */
  async createCompany(data: Partial<CompanyConfig>): Promise<CompanyConfig> {
    return await repositories.companyConfigs.create(data);
  }

  /**
   * Update company
   */
  async updateCompany(id: string, data: Partial<CompanyConfig>): Promise<CompanyConfig> {
    return await repositories.companyConfigs.update(id, data);
  }

  /**
   * Update company active status
   */
  async updateActiveStatus(id: string, isActive: boolean): Promise<CompanyConfig> {
    return await repositories.companyConfigs.updateActiveStatus(id, isActive);
  }

  /**
   * Delete company
   */
  async deleteCompany(id: string): Promise<void> {
    await repositories.companyConfigs.delete(id);
  }
}

// Export singleton instance
export const companyConfigService = new CompanyConfigService();
